/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Employee from './Employee/index'
import ExternalProfessional from './ExternalProfessional/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import Patient from './Patient/index'
import Payer from './Payer/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tag({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/EditOrAdd/Content/Content/Profiles/Content/Profile/ProfileData/Tag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || ''
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: personValueData,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Tag.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-mwk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={[].includes(flowValue)}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payer'}>
<Payer
  viewPath={`${viewPath}/Payer`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patient'}>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Employee'}>
<Employee
  viewPath={`${viewPath}/Employee`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ExternalProfessional'}>
<ExternalProfessional
  viewPath={`${viewPath}/ExternalProfessional`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}